// extracted by mini-css-extract-plugin
module.exports = {"container":"_3hEhhzL-o8WUIw07bheeco","button":"_1t8EFRwMmk6wWXOSRBZoJ-","ios":"cQUWRac3lMlqvCbiKTOfc","android":"_1Xc2Ldi6IBMmXcAW7uZ-0G"};